var rutoken = (function (my) {
  const loadCallbacks = [];
  let pluginMimeType = 'application/x-rutoken-pki';
  const extension = window['C3B7563B-BF85-45B7-88FC-7CFF1BD3C2DB'];

  function isFunction(obj) {
    return !!(obj && obj.call && obj.apply);
  }

  function proxyMember(target, member) {
    if (isFunction(target[member])) {
      return function () {
        return target[member](...arguments);
      };
    }
    return target[member];
  }

  function returnPromise(promise) {
    return function () {
      return promise;
    };
  }

  function initialize() {
    my.ready = Promise.resolve(true);
    my.isExtensionInstalled = returnPromise(Promise.resolve(false));
    my.isPluginInstalled = returnPromise(Promise.resolve(true));
    my.loadPlugin = loadPlugin;
    window.rutokenLoaded = onPluginLoaded;
  }

  function initializeExtension() {
    const readyPromise = extension.initialize().then(() => extension.isPluginInstalled()).then((result) => {
      my.isExtensionInstalled = returnPromise(Promise.resolve(true));
      my.isPluginInstalled = proxyMember(extension, 'isPluginInstalled');

      if (result) {
        pluginMimeType = 'application/x-rutoken-plugin';
        my.loadPlugin = loadChromePlugin;
      }

      return true;
    });

    my.ready = readyPromise;
  }

  function initializeWithoutPlugin() {
    my.ready = Promise.resolve(true);
    my.isExtensionInstalled = returnPromise(Promise.resolve(false));
    my.isPluginInstalled = returnPromise(Promise.resolve(false));
  }

  function loadPlugin() {
    const obj = document.createElement('object');
    obj.style.setProperty('visibility', 'hidden', 'important');
    obj.style.setProperty('width', '0px', 'important');
    obj.style.setProperty('height', '0px', 'important');
    obj.style.setProperty('margin', '0px', 'important');
    obj.style.setProperty('padding', '0px', 'important');
    obj.style.setProperty('border-style', 'none', 'important');
    obj.style.setProperty('border-width', '0px', 'important');
    obj.style.setProperty('max-width', '0px', 'important');
    obj.style.setProperty('max-height', '0px', 'important');

    // onload callback must be set before type attribute in IE earlier than 11.
    obj.innerHTML = "<param name='onload' value='rutokenLoaded'/>";
    // Just after setting type attribute before function returns promise
    // FireBreath uses onload callback to execute it with a small delay.
    // So it must be valid, but it will be called a little bit later.
    // In other browsers plugin will be initialized only after appending
    // an element to the document.
    obj.setAttribute('type', pluginMimeType);

    document.body.appendChild(obj);

    const promise = new Promise(((resolve, reject) => {
      loadCallbacks.push(resolve);
    }));

    return promise;
  }

  function loadChromePlugin() {
    return extension.loadPlugin().then(plugin => resolveObject(plugin)).then((resolvedPlugin) => {
      resolvedPlugin.wrapWithOldInterface = wrapNewPluginWithOldInterface;
      return resolvedPlugin;
    });
  }

  function onPluginLoaded(plugin, error) {
    wrapOldPluginWithNewInterface(plugin).then((wrappedPlugin) => {
      if (loadCallbacks.length == 0) {
        throw 'Internal error';
      }

      const callback = loadCallbacks.shift();
      callback(wrappedPlugin);
    });
  }

  function resolveObject(obj) {
    const resolvedObject = {};
    const promises = [];

    for (const m in obj) {
      (function (m) {
        if (isFunction(obj[m].then)) {
          promises.push(obj[m].then(result => resolveObject(result).then((resolvedProperty) => {
            if (isFunction(resolvedProperty)) {
              resolvedObject[m] = proxyMember(obj, m);
            } else {
              resolvedObject[m] = resolvedProperty;
            }
          })));
        } else {
          resolvedObject[m] = obj[m];
        }
      }(m));
    }

    if (promises.length == 0) {
      return new Promise(((resolve) => {
        resolve(obj);
      }));
    }
    return Promise.all(promises).then(() => resolvedObject);
  }

  function wrapNewPluginWithOldInterface() {
    const wrappedPlugin = {};

    for (const m in this) {
      if (isFunction(this[m])) {
        wrappedPlugin[m] = (function (plugin, member) {
          return function () {
            const successCallback = arguments[arguments.length - 2];
            const errorCallback = arguments[arguments.length - 1];
            const args = Array.prototype.slice.call(arguments, 0, -2);
            return member.apply(plugin, args).then((result) => {
              successCallback(result);
            }, (error) => {
              errorCallback(error.message);
            });
          };
        }(this, this[m]));
      } else {
        wrappedPlugin[m] = this[m];
      }
    }

    return new Promise(((resolve) => {
      resolve(wrappedPlugin);
    }));
  }

  function wrapOldPluginWithOldInterface() {
    const unwrappedPlugin = { originalObject: this.originalObject };

    for (const m in this.originalObject) {
      unwrappedPlugin[m] = proxyMember(this.originalObject, m);
    }

    return new Promise(((resolve) => {
      resolve(unwrappedPlugin);
    }));
  }

  function wrapOldPluginWithNewInterface(plugin) {
    const wrappedPlugin = {
      originalObject: plugin,
      wrapWithOldInterface: wrapOldPluginWithOldInterface,
    };

    for (const m in plugin) {
      if (isFunction(plugin[m])) {
        wrappedPlugin[m] = (function (plugin, member) {
          return function () {
            const args = Array.prototype.slice.call(arguments);
            return new Promise(((resolve, reject) => {
              args.push(resolve, reject);
              member.apply(plugin, args);
            }));
          };
        }(plugin, plugin[m]));
      } else {
        wrappedPlugin[m] = plugin[m];
      }
    }

    return new Promise(((resolve) => {
      resolve(wrappedPlugin);
    }));
  }

  if (extension) {
    initializeExtension();
  } else if (navigator.mimeTypes && navigator.mimeTypes[pluginMimeType]) {
    initialize();
  } else {
    try {
      const plugin = new ActiveXObject('Aktiv.CryptoPlugin');
      initialize();
    } catch (e) {
      initializeWithoutPlugin();
    }
  }

  return my;
}(rutoken || {}));

export default rutoken;
